import React from 'react';

export const TabButton = ({ active, onClick, icon: Icon, children }) => (
  <button
    onClick={onClick}
    className={`flex items-center gap-2 px-6 py-3 font-medium transition-all duration-300 border-b-2 ${
      active 
        ? 'text-blue-600 border-blue-600' 
        : 'text-gray-500 border-transparent hover:text-blue-600'
    }`}
  >
    <Icon className="w-4 h-4" />
    {children}
  </button>
);